import { Injectable } from "@angular/core";
import { HttpService } from "src/app/core/http/http.service";
import { GetProtocolsBody, GetProtocolsResponse, ProtocolDataResponse } from "../medical-record-page/pages/chemotherapy/model/protocol.interface";
import { ChemotherapyData } from "../medical-record-page/pages/chemotherapy/model/treatment.interface";
import { ActivePrinciple, Diluent, Medication } from "../medical-record-page/pages/chemotherapy/model/medications.model";
import { Chemotherapy } from "../medical-record-page/pages/chemotherapy/model/chemotherapy.model";
import { PatientService } from "src/app/shared/services/patient/patient-info.service";
import { PatientInfoAPI } from "../medical-record-page/pages/patient-informations/model/patient.model";
import { LastChemoDate } from "../medical-record-page/pages/chemotherapy/model/last-chemotherapy-date.model";

@Injectable({
  providedIn: 'root'
})
export class ChemotherapyService {

  patient: PatientInfoAPI | null = null;
  patientSelectedId: string | null = null;

  constructor(
    private httpService: HttpService,
    private patientInfoService: PatientService
  ) {
    this.patientInfoService.selectedPatientObs.subscribe(patient => {
      this.patient = patient;
    });

    this.patientInfoService.getPatientId().subscribe((patient) => {
      if (patient && this.patientSelectedId !== patient) {

        this.patientSelectedId = patient;
      }
    });
  }


  getProtocols(body: GetProtocolsBody) {
    return this.httpService.req<GetProtocolsResponse[]>('getProtocolByTNM', 'patient', {
      method: 'post',
      apiVersion: 2,
      params: {
        lg: 'pt-BR'
      },
      loaderKey: undefined,
      body
    })
  }

  getProtocolData(protocolId: number) {
    return this.httpService.req<ProtocolDataResponse[]>('getProtocolForNewChemo', 'patient', {
      method: 'get',
      apiVersion: 2,
      params: {
        lg: 'pt-BR',
        protocolId: protocolId.toString()
      },
    })
  }

  getSelectedPatientTreatments() {
    if (this.patientSelectedId === null) {
      throw new Error('nenhum paciente selecionado')
    }
    return this.httpService.req<ChemotherapyData[]>('getChemotherapy', 'patient', {
      loaderKey: 'get-quimioterapia',
      method: 'get',
      apiVersion: 2,
      params: {
        lg: 'pt-BR',
        patientId: this.patientSelectedId
      },
    })
  }

  getAllActivePrinciple() {
    return this.httpService.req<ActivePrinciple[]>('getAllActivePrinciple', 'patient', {
      method: 'get',
      apiVersion: 2,
      params: {
        lg: 'pt-BR'
      },
    })
  }

  getAllMedication(substanceId: string) {
    return this.httpService.req<Medication[]>('getAllMedications', 'patient', {
      method: 'get',
      apiVersion: 2,
      params: {
        lg: 'pt-BR',
        substance: substanceId
      },
    })
  }

  getAllDiluents() {
    return this.httpService.req<Diluent[]>('getAllDiluents', 'patient', {
      method: 'get',
      apiVersion: 2,
      params: {
        lg: 'pt-BR'
      },
    })
  }

  saveChemotherapy(data: Chemotherapy) {
    return this.httpService.req('postChemotherapy', 'patient', {
      method: 'post',
      apiVersion: 2,
      params: {
        lg: 'pt-BR'
      },
      body: data
    })
  }

  updateChemotherapy(data: Chemotherapy) {
    return this.httpService.req('putChemotherapy', 'patient', {
      method: 'put',
      apiVersion: 2,
      params: {
        lg: 'pt-BR'
      },
      body: data
    })
  }

  deleteChemotherapy(data: Chemotherapy) {
    return this.httpService.req('deleteChemotherapy', 'patient', {
      method: 'delete',
      apiVersion: 2,
      params: {
        lg: 'pt-BR',
        chemotherapyId: data.chemotherapyId
      },
      body: data
    })
  }

  getLastExecutedChemoDate() {
    if (this.patientSelectedId === null) {
      throw new Error('nenhum paciente selecionado');
    }
    return this.httpService.req<LastChemoDate>('getLastExecutedChemo', 'patient', {
      method: 'get',
      apiVersion: 2,
      params: {
        patientId: this.patientSelectedId,
        lg: 'pt-BR'
      },
    }).catch(error => {
      //exibir erro de busca
    });
  }

}
